// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".description[data-v-49e84fa5]{max-height:3em;overflow:hidden;text-overflow:ellipsis}.compilation-item__img2[data-v-49e84fa5]{width:408px;height:360px;display:flex;align-items:center;justify-content:center;background-color:#eee}.compilation-item__img2 .compilation-item__title[data-v-49e84fa5]{color:#040404}.compilation-item__img2 .compilation-item__img2-image[data-v-49e84fa5]{max-height:100%;max-width:100%;height:auto;width:auto!important}", ""]);
// Exports
module.exports = exports;
